import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import axios from "axios";
import LogisticRfqTable from "../Buyer/LogisticRfqTable";
import ItemCount from "../../../utils/ItemCount";

const LogisticPurchaseHeadDashboard = () => {
  const [rfqs, setRfqs] = useState();
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("logisticPurchaseHeadActiveTab") || "PROGRESS"
  );
  const [isLoading, setIsLoading] = useState(true);
  const [allCount, setAllCount] = useState(0);
  const [actionCount, setActionCount] = useState(0);
  const [recommendationCount, setRecommendationCount] = useState(0);
  const [concludedCount, setConcludedCount] = useState(0);
  const activeStatuses = ["ACCEPTING_BIDS", "BIDS_CLOSED", "REBIDDING", "EAUCTIONED", "SUBMITTED"];

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/logistic-draft?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        const all = res.data || [];
        setAllCount(all.filter(r => activeStatuses.includes(r.status)).length);
      } catch (error) {
        console.log(error);
      }

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/logistic/quotes/count-concluded?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setConcludedCount(res.data);
      } catch (error) {
        console.log(error);
      }

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/logistic/quote/count-action?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setActionCount(res.data);
      } catch (error) {
        console.log(error);
      }

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/logistic/quotes/count-recommendation?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setRecommendationCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCounts();
  }, []);

  useEffect(() => {
    const fetchTabData = async () => {
      setRfqs();
      setIsLoading(true);
      try {
        let res;

        if (activeTab === "PROGRESS") {
          res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/logistic-draft?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs((res.data || []).filter(r => activeStatuses.includes(r.status)));
        } else if (activeTab === "CONCLUDED") {
          res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/logistic/quote/concluded?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data || []);
        } else if (activeTab === "ACTION") {
          res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/logistic/quote/action-required?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data || []);
        } else if (activeTab === "RECOMMENDATION") {
          res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/logistic/quote/recommendation?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
          );
          setRfqs(res.data || []);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchTabData();
  }, [activeTab]);

  const switchTab = (tab) => {
    setActiveTab(tab);
    setIsLoading(true);
    localStorage.setItem("logisticPurchaseHeadActiveTab", tab);
  };

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box sx={{ display: "flex", gap: 1 }}>
            <Button
              className={`dashboard-btns ${activeTab === "PROGRESS" ? "active" : ""}`}
              onClick={() => switchTab("PROGRESS")}
            >
              In Quotes
              <ItemCount count={allCount} />
            </Button>
            <Button
              className={`dashboard-btns ${activeTab === "ACTION" ? "active" : ""}`}
              onClick={() => switchTab("ACTION")}
            >
              Action Required
              <ItemCount count={actionCount} />
            </Button>
            <Button
              className={`dashboard-btns ${activeTab === "RECOMMENDATION" ? "active" : ""}`}
              onClick={() => switchTab("RECOMMENDATION")}
            >
              In Recommendation
              <ItemCount count={recommendationCount} />
            </Button>
            <Button
              className={`dashboard-btns ${activeTab === "CONCLUDED" ? "active" : ""}`}
              onClick={() => switchTab("CONCLUDED")}
            >
              Concluded
              <ItemCount count={concludedCount} />
            </Button>
          </Box>
        </Box>
        <LogisticRfqTable
          rfqs={rfqs}
          activeTab={activeTab}
          isLoading={isLoading}
          showActionBtn={activeTab === "ACTION"}
          showQuoteStatus={activeTab === "RECOMMENDATION"}
          dashboardPath="logistic-purchase-head-dashboard"
        />
      </Box>
    </Box>
  );
};

export default LogisticPurchaseHeadDashboard;
